var _path, _circle, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWall3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 19,
    viewBox: "0 0 39 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4316 4.61865H2.08274H0.662109V6.03928V17.4043V18.8249H2.08274H32.6878H34.1084V17.4043V11.6778C33.8682 11.7068 33.6236 11.7218 33.3756 11.7218C33.143 11.7218 32.9135 11.7086 32.6878 11.683V17.4043H2.08274V6.03928H27.3482C27.3414 5.92176 27.3379 5.80335 27.3379 5.68412C27.3379 5.32057 27.3701 4.96451 27.4316 4.61865Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3753,
    cy: 5.68385,
    r: 2.91583,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.45791
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.1049,
    y1: 8.88037,
    x2: 14.1049,
    y2: 14.5629,
    stroke: "white",
    strokeWidth: 0.710313
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.8303,
    y1: 8.88037,
    x2: 22.8303,
    y2: 14.5629,
    stroke: "white",
    strokeWidth: 0.710313
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWall3);
export default __webpack_public_path__ + "static/media/icon-wall-3.c80e9f414bf9d295d974d1338cd4ef44.svg";
export { ForwardRef as ReactComponent };